<template>
  <tg-layout>
    <template slot="header">
      <div class="trial_step--container">
        <div class="trial_step--item active">
          <span>{{$t('page.member.trial.apply.label')}}</span>
          <i class="tg-icon tg-icon-check active"></i>
          <el-divider></el-divider>
        </div>
        <div class="trial_step--item" :class="activeClass">
          <el-divider></el-divider>
          <i class="tg-icon tg-icon-check" :class="activeClass"></i>
          <span>{{$t('page.member.trial.accomplish.label')}}</span>
        </div>
      </div>
    </template>
    <div
      v-loading="loading"
      :element-loading-text="$t('component.table.loading')"
      element-loading-spinner="el-icon-loading"
      element-loading-background="rgba(0, 0, 0, 0.8)"
    >
      <template v-if="!isAccomplish">
        <trial-apply-form :l20="username" @on-success="handleSuccess"></trial-apply-form>
      </template>
      <template v-else>
        <trial-apply-accomplish :l20="username" :row="trialData"></trial-apply-accomplish>
      </template>
    </div>
  </tg-layout>
</template>

<script>
import TgLayout from "@/layout/TgLayout";
import TrialApplyForm from "./trialApplyForm";
import TrialApplyAccomplish from "./trialApplyAccomplish";

export default {
  components: {
    TgLayout,
    TrialApplyForm,
    TrialApplyAccomplish
  },
  data() {
    return {
      isAccomplish: false,
      loading: false,
      trialData: ""
    };
  },
  props: {
    username: String
  },
  computed: {
    activeClass() {
      return {
        active: this.isAccomplish
      };
    }
  },
  created() {
    this.addBreadcrumb();
  },
  methods: {
    addBreadcrumb() {
      this.$store.commit("breadcrumb/add", {
        name: this.$route.name,
        query: {
          ...this.$route.query
        },
        params: {
          username: this.username
        },
        meta: {
          title: this.$t("page.member.trial.apply.breadcrumb", {
            name: this.username
          })
        }
      });
    },
    handleSuccess(formData) {
      this.trialData = formData;
      this.$nextTick(() => {
        this.isAccomplish = true;
      });
    }
  }
};
</script>